import React from "react";
import { Helmet } from "react-helmet";

const EpisodeOne = () => {
  const renderHeader = () => {
    return (
      <header className="container rounded-xl">
        <div className="max-w-screen-md mx-auto space-y-5">
          <h1
            className=" text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl "
            title="Quiet ingenuity: 120,000 lunches and counting"
          > Message One: Reality as You Perceive It
          </h1>
          <span className="block pb-1 text-base text-neutral-500 md:text-lg dark:text-neutral-400">
          Lou looks back on when she started her journey, searching for the person, or people, responsible for infecting her brother.
          </span>
          <div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
          <div className="flex flex-col items-center sm:flex-row sm:justify-between">
            <div className="flex flex-wrap items-center flex-shrink-0 text-sm leading-none text-left nc-PostMeta2 text-neutral-700 dark:text-neutral-200">
            </div>
          </div>
        </div>
      </header>
    );
  };

  const renderContent = () => {
    return (
      <div
        id="single-entry-content"
        className="mt-12 prose prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-invert"
      >
        <p><i>[Searching through radio channels, passing a music box playing “Au Clair de La Lune”,
          before stopping briefly on a staticky broadcast]</i>
        </p>
        <p><i><b>This is I.A.U. TREE ZERO EIGHT. I require assistance. Location is as follows.</b></i></p>
        <p><i>[Searching through radio channels continues, then stops]</i></p>
        <br/>
        <p><strong>LOU</strong></p>
        <p>I don’t know who might be listening to this. It wasn’t my fault, I didn’t — summon — that thing.</p>
        <p><i>[CLICK with static]</i></p>
        <p>
        This may be restored technology, but I know there are still hobbyists like my brother.
        Artisans, like the one allowing me to use his equipment — though,
        I wish he wouldn’t watch me with his face so close to the glass. Unmoving.
        You’d think he would be fogging up the surface, standing as close as he is.
        </p>
        <p>You know, I think he might be angry with me.</p>
        <p>Nevermind.</p>
        <p>It <i>is</i> possible that they’ll find me, if they hear this.
        If they tune into the right frequency.
        Maybe these broadcasts will just be additional evidence.</p>
        <p>But I <i>need</i> to tell someone.</p>
        <br/>
        <p>So, if you can hear this, listen to my side of what happened.</p>
        <br/>
        <p>The world as we know it is, exactly as you might perceive, and yet, nothing like it? At the same time.</p>
        <p>I learned this first by working through the academy.
          As a transcriber, I generally take down accounts of all forms of creatures, but specialize in unclassified entities.
          This doesn’t mean that they are new, per say, but rather ones that don’t fall into the categories already established
          in our town.</p>

        <p>Over the last two? Centuries? The academy hasn’t found a single previously undocumented creature.
          or history,
          or the first-hand accounts in the surrounding area.
          As in, something that has never shown up in the ancient scripts</p>
        <p>
        But I learned that my perception might not align with reality,
        by seeing something new and previously undocumented in our town, with my own eyes.
        </p>

        <br/>
        <p>I should say again, I did <i>not</i> summon that thing.</p>
        <br/>

        <p>A few months ago, I dragged a coffin through the graveyard outside of town.
          I staggered in the fog, avoiding the battered tombstones at my sides.
          It <i>is</i> difficult to sneak past the Stalkers, their spiderlike figures skulking in the moonlight.</p>
        
        <p>I think it was the smell.</p>
        <p>They’re not as keen to tear into a dead body, so in a way, the vampire I’d abducted was a sort of good luck token.</p>
        <p>At any rate, I was trying to outrun dawn. At the time, I just — I hoped he wouldn’t die too quickly?</p>
        <p>Yes, I do know how that sounds.</p>
        <p>I could get fired for harassment and intent to harm an entity.
          But after the event at the ruins, I’ve likely already lost my job. Which is too bad. I really needed the money.</p>
        <p>I pulled one of the chains over my shoulder. In the other hand, I held a crowbar.
        The coffin groaned as I reached the cemetery’s central plot. Red earth rose around me, as I turned the thing on its side.</p>
        <p>A howl echoed within the wood.
        It didn’t bother me, of course, it’s nothing compared to the wind at night, its screaming, crying.</p>
        <p><b>All through the night.</b></p>
        <p>Begging you to just open the door, please open the door.
          They’re coming, and if you don’t open the door, <strong>I <i>will</i> die</strong>.</p>
        <p>So, of course, it didn’t bother me.</p>
        <p>I banged on the coffin’s surface.</p>
        <p>“Nice to hear you’re up bright and early. Let’s get you out of bed.”</p>

        <p>Before he could even talk,
        I grit my teeth, and wedged the crowbar into the wooden lid. The planks creaked as I pried it open.
        A bright yellow eye peered out of the hole in the wood, and I jumped back.</p>
        <p>Sure, I knew he was in there, but… His face was pallid, lips tattered and sliced. Skin withered with each breath.</p>
        <p>He didn’t look like some of the other vampires in town, who I assume are blending in.
        Biding their time. Waiting to find you out alone after curfew. This vampire was new. Very new.</p>
        <p>I rounded the coffin, the chain squealing in my fists.
        Broken tumbleweeds scattered the desert dirt, and dried grass and ivy surrounded the statue above us.</p>
        <p>Holding the crowbar, I put a foot against the lip and started to wrench it open again.
        The vampire’s fingers scrambled to get a hold of my boot.</p>
        <p>It set my nerves on fire.
        I bashed his knuckles with the bar until he pulled his hands back in, screaming.</p>
        <p>And I… I relished in it. There’s something strange about that, now that I say it out loud.
        I don’t think I’ve always been so cruel.</p>
        <p><i>[Over Au Clair de la Lune playing faintly in the background]</i></p>
        <p>But things are… <b><i>Different, now. So much I need to do. To heal, to kill.</i></b></p>
        <p><i>[music fades]</i></p><p>Or— no, I don’t why I said that. I only want answers.</p><p>That’s all.</p>
        <p>I… uh… I popped open the coffin.</p>
        <p>The vampire tumbled out onto the dirt, into the fog, upon hallowed ground.
        He clutched his hands to his chest. Stared at the broken pieces of himself.</p>
        <p>He asked me, “Why are you doing this?”</p>
        <p>And then he looked up at me. I could almost spot the humanity behind his metal irises.
        Smears of dirt painted his pale face, sweeping across his cheek, to his pointed ear.</p>
        
        <p>I knelt beside him. “Which one of your clan turned my brother?”</p>
        <p>“Clan? What are you talking about?”</p>
        <p>He didn’t seem very open to helping.</p>
        <p>I tapped the statue beside us, then ripped off the vines that crossed its rusted plaque.
        The epitaph was faded, but you could clearly see the words… <i>HERE LIES GOLIATH</i>.</p>
        <p>A muscle twitched under the vampire’s eye, when he realized where he was.
        Maybe he knew, then, who <i>I</i> am.
        It’s all the town wants to talk about, in their hushed murmurs.</p>
        <p>An undulating chorus, following wherever I walk. Like a chant.
        They might think I can’t hear them, that I don’t notice them standing at their windows, all of them,
        chanting in unison, when I leave for work in the morning. Goliath, Goliath.</p>
        <p>It’s unfortunate that I haven’t earned that name. Goliath, I mean.
        As far as I’m concerned, it’s just a family name, nothing more.
        But the town clearly disagreed.
        They kept statues like these. As if the things act as a protective barrier.
        And when I do hear their whispers, they talk of… of—</p>
        <p><i>[Over Au Clair de la Lune playing faintly in the background]</i></p>
        <p><strong><i>Of something greater and darker. They have their beliefs. And maybe, they’re right.</i></strong></p>
        <p><i>[CLICK with static]</i></p>
        <p>Huh. That was— I'll… Continue.</p>
        <p>I swung the chain and lashed at the vampire’s face. He took the chance—yanked it, pulling me closer.
        The chain’s links pinched my skin and blood dripped onto my hands, streaming from his wounded mouth.</p>
        <p>“What sort of symptoms is he showing? Eating bloody meat?
        Sleeping during daylight? None of that means anything, and you should know that.”</p>
        <p>“He’s <i>sick</i>.”</p>
        <p>The vampire struggled to his feet and studied the statue. Green marble towered over us.
        It was a cloaked figure, the carving so intricate it looked like real cloth.
        The figure held a lantern in its bony fingers.</p>
        <p>“He’s just sick? And <i>you’re</i> ready to go to jail, over a guess?”</p>
        <p>It took me a moment, to really hear him?</p>

        <p>Steam whisked around us, and I could see him being drawn to the statue, too.
        Inching closer, listening for the low growl that emanated the stone.</p>
        <p>As he marveled at the figure above us, he scratched at his neck and a slice of skin came off between his fingers.
        Swearing under his breath, he glanced at the sky.
        “Ask Benny about it, I don’t have time for this.”</p>
        <p>“The drunkard? What the hell would he know that you don’t?”</p>
        <p>The vampire’s eyes went wide, and I turned to see it, too. Oranges and pinks bled into the sky.
        He hurried, tripping, crawling to hide under the coffin.</p>
        <p>“Nail me back in,” he pleaded. “<i>Nail me back in</i><i>!</i>”</p>
        <p>I crouched, watching him, wondering if my brother felt as terrified as this, the night he started to turn.
        The night that <i>I</i> pulled him up the stairs to his bed.</p>
        <p>Followed by nights of me feeding him raw, finely diced meat mixed with milk,
        as he lost the strength to chew through the pounds and pounds of flesh that he was craving.
        Days, watching him fade into nothingness. Hoping that I was wrong.</p>
        <p>Grey clouds drifted over the sun, casting shadows, leaving trails of Godsrays over the horizon.
        I picked up the coffin’s lid from its place on the ground.</p>
        <p><i>[Over Au Clair de la Lune playing faintly in the background]</i></p>
        <p><b><i>And I watched him there, for a moment, memorizing his huddled form in the coffin.</i></b></p
        ><p><i>[music fades]</i></p><p>And then I — and then… I walked away.
        With the lid. Leaving one long trench in my wake.</p>
        <p><i>[CLICK with static]</i></p>
        <p>Now, you have to understand — even if you’re on the jury, for the trial awaiting me. Even if you’re one of them.
        Even if you’re particularly sympathetic to new generations of beasts,
        and you think <i>I’m</i> a monster for dragging <i>him</i> out into the sun.</p>
        <p>For leaving him, there.</p><p>I have to find who did this to my brother. I need to—</p>
        <p>I can hear them, now. The chorus, the murmur. That hum in the floorboards.
        The artisan hasn’t moved from his place behind the glass.</p>
        <p>I think he’s waiting for me to leave! Which is fair enough.</p>
        <p>What I need to do first and foremost, is find another place to hide.</p>
        <p>But if you care about what’s happening here, what is happening <i>to our world</i>…</p>
        <p><i>[Static ends. Said over “Thumb” by Monophona]</i></p><p><b>Remember this frequency.</b></p>
        <p>I’ll talk to you again soon.</p>
        <hr/>
        <p><i>[Searching through radio channels, stopping on the same staticky broadcast from earlier]</i></p>
        <p><b>FIFE point FIFE, South? Five degrees. Nothing else follows.</b></p>
        <p><i>[Searching over radio channels continues, then settles. Spoken over “Thumb” by Monophona]</i></p>
        <p>The Moon Crown is a bi-weekly podcast by me, your host, Agent Molder.
        You can Tweet at, comment at, reblog, or follow TheMoonCrownPod on Tumblr, Twitter, and TikTok.</p>
        <p>You can also find more about this show, along with any music or sound effects used here, at themooncrown.netlify.app.
        That’s “A P P”.</p>
        <p>Thanks for listening.</p><p>See you next time.</p><p>[CLICK with static]</p>

        <hr/>
        <h2>SFX and Music</h2>
        <ul>
          <li><a href="https://freesound.org/people/MPTSound/sounds/552482/">
            <p>"Tuning radio.wav" by MPTSound</p></a></li>
          <li><a href="https://freesound.org/people/bilwiss/sounds/24724/">
            <p>"Musicbox_Au_clair_de_la_lune.WAV" by bilwiss</p></a></li>
          <li>
          <a href="https://freesound.org/people/trip_sound/sounds/190472/">
            <p>“Analog Radio” by trip_sound</p>
          </a>
          </li>
          <li>
          <a href="https://freesound.org/people/joedeshon/sounds/329673/">
            <p>“Static” by joedeshon</p></a>
          </li>
          <li>
          <a href="https://soundcloud.com/monophona/thumb">
            <p>"Thumb" by Monophona</p></a>
          </li>
        </ul>
        
        <a href="https://twitter.com/themooncrownpod">
          <p>Don't forget, you can find the podcast on Twitter @themooncrownpod!</p>
        </a>
      </div>
    );
  };

  return (
    <div className="pt-8 nc-PageSingle lg:pt-16">
      <Helmet>
        <title>The Moon Crow, Episode One Transcript</title>
      </Helmet>
      {renderHeader()}

      <div className="container space-y-10 nc-SingleContent">
        {renderContent()}
        <div className="max-w-screen-md mx-auto border-t border-b border-neutral-100 dark:border-neutral-700"></div>
      </div>
    </div>
  );
};

export default EpisodeOne;
